import { type Meta } from '../types/docs';
import { AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM } from './automationsAnalytics';

const META: Meta = {
  description: 'The user expands or collapses the automations section in the agent tasks list',
  name: 'automation_tasks_section_toggled',
  params: [
    AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'Whether the section is expanded after the toggle',
      name: 'is_expanded',
      required: true,
      type: 'boolean',
    },
    {
      description: 'Number of automations in the section when toggled',
      name: 'automation_count',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
